import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getRelativePathBasedOnDomain from 'lib/getRelativePathBasedOnDomain';

const typesRequired = ['link', 'buttonWithArrow', 'buttonWithIcon', 'subscribeButton', 'button'];

const mapStateToProps = ({ router }) => ({
  domain: router.domain,
  currentPath: router.path,
});

@connect(mapStateToProps)
class ButtonHoverAnimation extends React.Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    currentPath: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    domain: PropTypes.string.isRequired,
    hasDarkBackground: PropTypes.bool,
    iconStyle: PropTypes.string,
    id: PropTypes.string,
    onClick: PropTypes.func,
    size: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    titleStyle: PropTypes.string,
    type: PropTypes.oneOf(typesRequired).isRequired,
    url: PropTypes.string,
  };

  static defaultProps = {
    additionalClasses: '',
    disabled: false,
    hasDarkBackground: false,
    iconStyle: '',
    id: '',
    onClick: null,
    size: 'normal',
    target: '_self',
    title: '',
    titleStyle: '',
    url: null,
  };

  render() {
    const {
      type, size, hasDarkBackground, additionalClasses, disabled,
    } = this.props;

    const baseButtonClassName = 'animated-ghost-button';

    const buttonSize = `${baseButtonClassName}--${size}`;
    let modifierClass;
    if (hasDarkBackground) {
      modifierClass = `${baseButtonClassName}--darkBackground`;
    }

    const buttonClassString = classNames(
      baseButtonClassName,
      buttonSize,
      modifierClass,
      additionalClasses,
      { disabled },
    );

    switch (type) {
      case 'link': {
        const {
          title, url, domain, currentPath, target,
        } = this.props;
        if (!url || currentPath === getRelativePathBasedOnDomain(url, domain)) {
          return null;
        }
        return (
          <a href={url} className={buttonClassString} target={target}>
            {title}
          </a>
        );
      }

      case 'buttonWithIcon': {
        const {
          iconStyle, titleStyle, title,
        } = this.props;
        return (
          <button
            type="button"
            className={baseButtonClassName}
          >
            <span className={iconStyle} />
            <span className={titleStyle}>{title}</span>
          </button>
        );
      }

      case 'subscribeButton': {
        const { onClick, title } = this.props;
        if (onClick) {
          return (
            <button
              type="button"
              className={buttonClassString}
              onClick={onClick}
            >
              {title}
            </button>
          );
        }
        return null;
      }

      case 'buttonWithArrow': {
        const {
          iconStyle, id, onClick, title,
        } = this.props;
        if (onClick) {
          return (
            <button
              {...id && { id }}
              type="button"
              className={buttonClassString}
              onClick={onClick}
            >
              {title}
              <span className={iconStyle} />
            </button>
          );
        }
        return null;
      }

      default: {
        const {
          id, onClick, title,
        } = this.props;
        if (onClick) {
          return (
            <button
              {...id && { id }}
              type="button"
              className={buttonClassString}
              onClick={onClick}
              disabled={disabled}
            >
              {title}
            </button>
          );
        }
        return null;
      }
    }
  }
}

export default ButtonHoverAnimation;
